import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {connect} from 'react-redux';
import {GeneralContent, Systems, Incidents, Status} from "../Redux/ContentfulContentGrabber";

class ListItemsComponent extends Component {

    //Gathers all the contentful data from Redux before the component mounts
    componentWillMount() {
        this.props.fetchSystemData();
        this.props.fetchIncidentsData();
    }

    getSystemRowsFromContentful() {
        let listOfAllSystemStatuses = [];
        for (let i = 0; i < this.props.systems.items.length; i++) {
            listOfAllSystemStatuses.push(this.props.systems.items[i].fields.name.toString());
        }
        return listOfAllSystemStatuses;
    }

    //This sorts the statuses by the most sever outages at the top to the less sever at the bottom such as maintenance
    static sortStatusListByStatusLevel(unorderedStatus) {
        return unorderedStatus.sort(function (a, b) {
            return a[2] < b[2] ? 1 : -1;
        });
    }

    renderStatusData() {
        let unorderedSystemsListFromContentful = this.getSystemRowsFromContentful();
        let orderedSystemsListFromContentful = ListItemsComponent.sortStatusListByStatusLevel(unorderedSystemsListFromContentful);
        let incidentListPerSystem = this.createIncidentListArrays(orderedSystemsListFromContentful);
        let systemRows = [];

        for (let i = 0; i < orderedSystemsListFromContentful.length; i++) {
            let systemIcons = [];
            for (let j = 0; j < incidentListPerSystem[i].length; j++) {
                if (incidentListPerSystem[i][j].fields.resolved === false) {
                    let statusIconURL = incidentListPerSystem[i][j].fields.status.fields.statusIcon.fields.file.url;
                    systemIcons.push(
                        <div className={"systemIcon"}>
                            <img
                                src={statusIconURL}
                                draggable="false"
                                width="20"
                                alt="System Image"
                            />
                        </div>
                    );
                }
            }

            if (systemIcons.length === 0) {
                systemIcons.push(
                    <img
                        src={this.props.status.items[3].fields.statusIcon.fields.file.url} draggable="false"
                        width="20"
                        alt="System Image"
                    />
                );
            }

            systemRows.push(
                <div key={i} className="service header text_left">
                    <div className="flex_column">
                        <p className="fontRegularMedium"
                           style={{marginBottom: "0"}}>{orderedSystemsListFromContentful[i]}</p>
                    </div>
                    <div className="flex_row align_center">
                        {systemIcons}
                    </div>
                </div>
            );
        }
        return systemRows;
    }

    createIncidentListArrays(orderedSystemsListFromContentful) {
        let incidentList = [];
        for (let i = 0; i < orderedSystemsListFromContentful.length; i++) {
            let incidentsForEachSystem = [];
            incidentList.push(incidentsForEachSystem);
        }

        for (let i = 0; i < this.props.incidents.items.length; i++) {
            for (let x = 0; x < orderedSystemsListFromContentful.length; x++) {
                if (orderedSystemsListFromContentful[x].toString() === this.props.incidents.items[i].fields.system.fields.name.toString()) {
                    incidentList[x].push(this.props.incidents.items[i]);
                }
            }
        }
        return incidentList;
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.systems) && !Array.isArray(this.props.incidents) && !Array.isArray(this.props.status) && !Array.isArray(this.props.generalContent);
    }

    render() {
        if (this.isContentfulContentAvailableYet()) {
            return (
                <ReactCSSTransitionGroup
                    transitionName="example"
                    transitionAppear={true}
                    transitionAppearTimeout={50000}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div id="services">
                        {this.renderStatusData()}
                    </div>
                </ReactCSSTransitionGroup>
            );
        }
        //return nothing if contentful content isn't available yet
        return (null);
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        systems: state.systems,
        status: state.status,
        incidents: state.incidents,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent()),
        fetchSystemData: () => dispatch(Systems()),
        fetchStatusData: () => dispatch(Status()),
        fetchIncidentsData: () => dispatch(Incidents())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListItemsComponent);


// WEBPACK FOOTER //
// ./src/Components/ListItemsComponent.js